<template>
    <div class="page-wrap">
        <div class="top-card">
            <div class="l-box" style="width: 100%;">
                <div class="nav_title">合同审批</div>
                <div class="input-group">
                    <div class="flex f-wrap">
                        <div class="wrap flex">
                            <div class="label">检索：</div>
                            <div class="r-find">
                                <Input
                                    v-model="storePrams.keyword"
                                    placeholder="请输入合同名称"
                                    style="width: 240px"
                                    clearable
                                />
                            </div>
                        </div>
                        <div class="wrap flex">
                            <div class="label">状态：</div>
                            <div class="r-find">
                                <Select
                                    v-model="storePrams.status"
                                    style="width: 200px"
                                    clearable
                                    placeholder="全部"
                                >
                                    <Option
                                        v-for="item in statusList"
                                        :value="item.value"
                                        :key="item.value"
                                    >{{ item.label }}</Option>
                                </Select>
                            </div>
                        </div>
                        <div class="wrap flex">
                            <div class="label">申请日期：</div>
                            <div class="r-find">
                                <DatePicker
                                    v-model="timeVal"
                                    @on-change="changeTime"
                                    type="daterange"
                                    placement="bottom-end"
                                    placeholder="点击选择时间"
                                    style="width: 250px"
                                />
                            </div>
                        </div>
                        <div class="r-btn flex wrap">
                            <Button @click="getListSearch" type="primary">查询</Button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="table_card">
            <Table :loading="loading" :columns="tableColumns" :data="data">
                <template slot-scope="{ index }" slot="index">
                    <div>{{ (storePrams.page - 1) * storePrams.limit + index + 1 }}</div>
                </template>
                <template slot-scope="{ row }" slot="contract_name">
                    <div>{{ getContractName(row) }}</div>
                </template>
                <template slot-scope="{ row }" slot="applicant">
                    <div>{{ getApplicantName(row) }}</div>
                </template>
                <template slot-scope="{ row }" slot="status">
                    <div :class="getStatusClass(row.status)">{{ getStatusText(row) }}</div>
                </template>
                <template slot-scope="{ row }" slot="apply_time">
                    <div>{{ row.created_at || row.apply_time || '-' }}</div>
                </template>
                <template slot-scope="{ row }" slot="operation">
                    <div class="operation-btns">
                        <div
                            v-if="showWithdrawBtn(row)"
                            class="table-btn danger"
                            @click="handleWithdraw(row)"
                        >撤回审批</div>
                        <div
                            v-if="showApproveBtn(row)"
                            class="table-btn approve-btn"
                            @click="handleApprove(row)"
                        >审批</div>
                        <div
                            v-if="showRejectReasonBtn(row)"
                            class="table-btn reject-reason-btn"
                            @click="viewRejectReason(row)"
                        >{{ Number(row.status) === 5 ? '失败原因' : '拒绝原因' }}</div>
                        <div
                            v-if="showRegenerateBtn(row)"
                            class="table-btn regenerate-btn"
                            @click="handleRegenerate(row)"
                        >重新生成</div>
                        <div
                            v-if="showProgressBtn(row)"
                            class="table-btn blue"
                            @click="openProgress(row)"
                        >审批进度</div>
                        <div class="table-btn del" @click="seeDetail(row)">详情</div>
                    </div>
                </template>
            </Table>
            <Page
                :total="storePrams.total"
                :current="storePrams.page"
                style="text-align:right;margin-top: 20px"
                show-elevator
                show-total
                @on-change="pageChange"
                :page-size="storePrams.limit"
            />
        </div>

        <contract-preview ref="contractPreview" />
        <approval-progress ref="approvalProgress" />

        <Modal
            title="审批"
            v-model="showApproveModal"
            :mask-closable="false"
            width="520"
            class-name="approve-action-modal"
        >
            <div class="approve-card" v-if="currentRow">
                <div class="approve-card-head">
                    <div class="approve-contract-name">{{ getContractName(currentRow) }}</div>
                    <div class="view-contract-link" @click="previewFromApprove">查看合同</div>
                </div>
                <div class="approve-info-row">
                    <span class="info-label">发起方：</span>
                    <span class="info-value">{{ approveDetail.initiator || '-' }}</span>
                </div>
                <div class="approve-info-row">
                    <span class="info-label">签署方：</span>
                    <span class="info-value">{{ approveDetail.signatories || '-' }}</span>
                </div>
            </div>
            <div slot="footer">
                <Button @click="openRejectForm">拒绝</Button>
                <Button type="primary" :loading="approveSubmitting" @click="submitAgree">同意</Button>
            </div>
        </Modal>

        <Modal
            title="拒绝原因"
            v-model="showRejectFormModal"
            :mask-closable="false"
            width="520"
        >
            <div class="reject-form-tip" v-if="currentRow">
                您将拒绝【{{ getContractName(currentRow) }}】的审批，请填写理由：
            </div>
            <Input
                v-model="rejectReason"
                type="textarea"
                :rows="5"
                maxlength="500"
                placeholder="请输入拒绝理由"
            />
            <div slot="footer">
                <Button @click="showRejectFormModal = false">取消</Button>
                <Button type="primary" :loading="approveSubmitting" @click="submitReject">确定</Button>
            </div>
        </Modal>

        <Modal
            :title="reasonViewTitle"
            v-model="showReasonViewModal"
            :mask-closable="false"
            width="520"
            footer-hide
        >
            <div class="reason-view-content">{{ currentReason || '暂无相关说明' }}</div>
        </Modal>

        <Modal
            title="撤回审批"
            v-model="showWithdrawModal"
            :mask-closable="false"
            width="480"
        >
            <div class="withdraw-content">
                <Icon type="md-alert" class="withdraw-icon" />
                <span>是否确认撤回 【{{ withdrawContractName }}】 的审批！</span>
            </div>
            <div slot="footer">
                <Button @click="showWithdrawModal = false">取消</Button>
                <Button type="primary" :loading="withdrawSubmitting" @click="confirmWithdraw">确定</Button>
            </div>
        </Modal>

        <Modal
            title="重新生成"
            v-model="showRegenerateModal"
            :mask-closable="false"
            width="480"
        >
            <div class="withdraw-content">
                <Icon type="md-alert" class="withdraw-icon" />
                <span>是否确认重新生成 【{{ regenerateContractName }}】 的合同？</span>
            </div>
            <div slot="footer">
                <Button @click="showRegenerateModal = false">取消</Button>
                <Button type="primary" :loading="regenerateSubmitting" @click="confirmRegenerate">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<script>
import ContractPreview from './components/contractPreview.vue'
import ApprovalProgress from './components/approvalProgress.vue'
import {
    contractApproveList,
    contractApproveExamine,
    contractApproveRevoke,
    contractApproveDetail,
    contractApproveRegenerate,
    contractDetails
} from '@/api/interFace'

/** 0待审核 1审批中 2已通过 3已驳回 4已撤销 5创建失败 */
const STATUS_MAP = {
    0: { text: '待审核', class: 'status-pending' },
    1: { text: '审批中', class: 'status-reviewing' },
    2: { text: '已通过', class: 'status-passed' },
    3: { text: '已驳回', class: 'status-rejected' },
    4: { text: '已撤销', class: 'status-revoked' },
    5: { text: '创建失败', class: 'status-failed' }
}

export default {
    name: 'contractExamine',
    components: {
        ContractPreview,
        ApprovalProgress
    },
    data() {
        return {
            loading: false,
            data: [],
            timeVal: [],
            statusList: [
                { label: '全部', value: '' },
                { label: '待审核', value: '0' },
                { label: '审批中', value: '1' },
                { label: '已通过', value: '2' },
                { label: '已驳回', value: '3' },
                { label: '已撤销', value: '4' },
                { label: '创建失败', value: '5' }
            ],
            tableColumns: [
                { title: '#', slot: 'index', width: 70, align: 'center' },
                { title: '合同名称', slot: 'contract_name', align: 'center', minWidth: 280 },
                { title: '申请人', slot: 'applicant', align: 'center', width: 160 },
                { title: '状态', slot: 'status', align: 'center', width: 120 },
                { title: '申请时间', slot: 'apply_time', align: 'center', width: 180 },
                { title: '操作', slot: 'operation', align: 'center', fixed: 'right', width: 380 }
            ],
            storePrams: {
                limit: 10,
                page: 1,
                total: 0,
                keyword: '',
                status: '',
                start_time: '',
                end_time: ''
            },
            currentRow: null,
            approveDetail: {
                initiator: '',
                signatories: '',
                contractId: '',
                contractImgs: [],
                failReason: '',
                detailData: null
            },
            showApproveModal: false,
            showRejectFormModal: false,
            showReasonViewModal: false,
            showWithdrawModal: false,
            showRegenerateModal: false,
            rejectReason: '',
            currentReason: '',
            withdrawRow: null,
            withdrawContractName: '',
            regenerateRow: null,
            regenerateContractName: '',
            reasonViewTitle: '拒绝原因',
            approveSubmitting: false,
            withdrawSubmitting: false,
            regenerateSubmitting: false
        }
    },
    created() {
        this.$store.commit('changePollingSpin', false)
        this.getList()
    },
    methods: {
        getList() {
            this.loading = true
            const params = {
                page: this.storePrams.page,
                limit: this.storePrams.limit,
                keyword: this.storePrams.keyword || undefined,
                status: this.storePrams.status === '' || this.storePrams.status == null
                    ? undefined
                    : this.storePrams.status,
                start_time: this.storePrams.start_time || undefined,
                end_time: this.storePrams.end_time || undefined
            }
            contractApproveList(params).then(res => {
                const pageData = res.data || {}
                const list = pageData.data || []
                this.data = Array.isArray(list) ? list : []
                this.storePrams.total = pageData.total || 0
            }).catch(err => {
                this.data = []
                this.storePrams.total = 0
                this.$Message.error((err && err.msg) || '获取审批列表失败')
            }).finally(() => {
                this.loading = false
            })
        },
        getListSearch() {
            this.storePrams.page = 1
            this.getList()
        },
        pageChange(index) {
            this.storePrams.page = index
            this.getList()
        },
        changeTime(val) {
            if (val && val.length === 2 && val[0] && val[1]) {
                this.storePrams.start_time = val[0]
                this.storePrams.end_time = val[1]
            } else {
                this.storePrams.start_time = ''
                this.storePrams.end_time = ''
            }
        },
        getContractName(row) {
            return row.contract_name || '-'
        },
        getContractId(row) {
            return row.contract_id || (this.approveDetail && this.approveDetail.contractId) || ''
        },
        getApplicantName(row) {
            return row.applicant_name || '-'
        },
        getStatusText(row) {
            const hit = STATUS_MAP[Number(row.status)]
            if (hit) return hit.text
            return row.status_text || '-'
        },
        getStatusClass(status) {
            const hit = STATUS_MAP[Number(status)]
            return hit ? hit.class : ''
        },
        /** identity: 1申请人 2审批人 3已审批 4查看；pid=0 为平台主账号 */
        isPlatformMain() {
            const userInfo = this.$store.state.userInfo || {}
            return Number(userInfo.pid) === 0
        },
        showWithdrawBtn(row) {
            const status = Number(row.status)
            // 仅待审核可撤回；审批中不展示
            return Number(row.identity) === 1 && status === 0
        },
        showApproveBtn(row) {
            const status = Number(row.status)
            return Number(row.identity) === 2 && (status === 0 || status === 1)
        },
        showRejectReasonBtn(row) {
            const status = Number(row.status)
            return status === 3 || status === 5
        },
        /** 创建失败：申请人或平台主账号可重新生成 */
        showRegenerateBtn(row) {
            return Number(row.status) === 5
                && (Number(row.identity) === 1 || this.isPlatformMain())
        },
        /** 已撤销/创建失败不展示审批进度 */
        showProgressBtn(row) {
            const status = Number(row.status)
            return status === 0 || status === 1 || status === 2 || status === 3
        },
        formatParticipants(detail) {
            const names = detail.paraticipant_name || detail.participant_name || ''
            const phones = detail.paraticipant_phone || detail.participant_phone || ''
            if (names) return String(names).replace(/,/g, '、')
            if (phones) return String(phones).replace(/,/g, '、')
            return ''
        },
        seeDetail(row) {
            const contractId = row.contract_id
            if (contractId) {
                this.$refs.contractPreview.openByContractId(contractId)
                return
            }
            const imgs = row.contract_imgs
            if (Array.isArray(imgs) && imgs.length) {
                this.$refs.contractPreview.openByData({
                    id: row.id,
                    contract_name: row.contract_name,
                    contract_imgs: imgs
                })
                return
            }
            // 审批中可能尚未生成正式合同，拉详情再试
            contractApproveDetail({ id: row.id }).then(res => {
                const detail = res.data || {}
                if (detail.contract_id) {
                    this.$refs.contractPreview.openByContractId(detail.contract_id)
                    return
                }
                const detailImgs = detail.contract_imgs
                if (Array.isArray(detailImgs) && detailImgs.length) {
                    this.$refs.contractPreview.openByData({
                        id: detail.id || row.id,
                        contract_name: detail.contract_name || row.contract_name,
                        contract_imgs: detailImgs
                    })
                    return
                }
                this.$Message.warning('暂无合同信息（审批通过后才会生成正式合同）')
            }).catch(() => {
                this.$Message.warning('暂无合同信息')
            })
        },
        previewFromApprove() {
            if (this.approveDetail.contractId) {
                this.$refs.contractPreview.openByContractId(this.approveDetail.contractId)
                return
            }
            if (this.approveDetail.contractImgs && this.approveDetail.contractImgs.length) {
                this.$refs.contractPreview.openByData({
                    id: this.currentRow && this.currentRow.id,
                    contract_name: this.currentRow && this.currentRow.contract_name,
                    contract_imgs: this.approveDetail.contractImgs
                })
                return
            }
            if (this.currentRow) this.seeDetail(this.currentRow)
        },
        loadApproveDetail(row) {
            this.approveDetail = {
                initiator: this.getApplicantName(row),
                signatories: this.formatParticipants(row) || '-',
                contractId: row.contract_id || '',
                contractImgs: Array.isArray(row.contract_imgs) ? row.contract_imgs : [],
                failReason: row.fail_reason || row.refuse_reason || '',
                detailData: null
            }
            return contractApproveDetail({ id: row.id }).then(res => {
                const detail = res.data || {}
                this.approveDetail = {
                    initiator: this.getApplicantName(row),
                    signatories: this.formatParticipants(detail) || this.formatParticipants(row) || '-',
                    contractId: detail.contract_id || row.contract_id || '',
                    contractImgs: Array.isArray(detail.contract_imgs) && detail.contract_imgs.length
                        ? detail.contract_imgs
                        : (Array.isArray(row.contract_imgs) ? row.contract_imgs : []),
                    failReason: detail.fail_reason || row.fail_reason || '',
                    detailData: detail
                }
                // 若已有正式合同，补充签署方
                if (this.approveDetail.contractId && this.approveDetail.signatories === '-') {
                    return contractDetails({ id: this.approveDetail.contractId, pcStatus: 1 }).then(cRes => {
                        const data = cRes.data || {}
                        const participants = data.participant || []
                        const signatories = participants.map(p => {
                            return p.prise_name || p.name || p.participants || ''
                        }).filter(Boolean).join('、')
                        if (signatories) this.approveDetail.signatories = signatories
                        if (data.initiator) this.approveDetail.initiator = data.initiator
                    }).catch(() => {})
                }
            }).catch(() => {})
        },
        handleApprove(row) {
            this.currentRow = row
            this.rejectReason = ''
            this.showApproveModal = true
            this.loadApproveDetail(row)
        },
        openRejectForm() {
            this.rejectReason = ''
            this.showRejectFormModal = true
        },
        submitAgree() {
            if (!this.currentRow) return
            this.approveSubmitting = true
            contractApproveExamine({
                id: this.currentRow.id,
                status: 1,
                remark: '同意'
            }).then(res => {
                this.$Message.success(res.msg || '审批通过')
                this.showApproveModal = false
                this.getList()
            }).catch(err => {
                this.$Message.error((err && err.msg) || '操作失败')
            }).finally(() => {
                this.approveSubmitting = false
            })
        },
        submitReject() {
            if (!this.rejectReason.trim()) {
                this.$Message.warning('请输入拒绝理由')
                return
            }
            if (!this.currentRow) return
            this.approveSubmitting = true
            contractApproveExamine({
                id: this.currentRow.id,
                status: 2,
                remark: this.rejectReason.trim()
            }).then(res => {
                this.$Message.success(res.msg || '已驳回')
                this.showRejectFormModal = false
                this.showApproveModal = false
                this.getList()
            }).catch(err => {
                this.$Message.error((err && err.msg) || '操作失败')
            }).finally(() => {
                this.approveSubmitting = false
            })
        },
        viewRejectReason(row) {
            const isFail = Number(row.status) === 5
            this.reasonViewTitle = isFail ? '失败原因' : '拒绝原因'
            const localReason = isFail
                ? (row.fail_reason || '')
                : (row.refuse_reason || row.fail_reason || '')
            if (localReason) {
                this.currentReason = localReason
                this.showReasonViewModal = true
                return
            }
            contractApproveDetail({ id: row.id }).then(res => {
                const detail = res.data || {}
                this.currentReason = isFail
                    ? (detail.fail_reason || '暂无失败原因')
                    : (detail.refuse_reason || detail.fail_reason || '暂无拒绝原因')
                this.showReasonViewModal = true
            }).catch(() => {
                this.currentReason = isFail ? '暂无失败原因' : '暂无拒绝原因'
                this.showReasonViewModal = true
            })
        },
        openProgress(row) {
            this.$refs.approvalProgress.open(row.id)
        },
        handleWithdraw(row) {
            this.withdrawRow = row
            this.withdrawContractName = this.getContractName(row)
            this.showWithdrawModal = true
        },
        confirmWithdraw() {
            if (!this.withdrawRow) return
            this.withdrawSubmitting = true
            contractApproveRevoke({
                id: this.withdrawRow.id,
                remark: '撤回审批'
            }).then(res => {
                this.$Message.success(res.msg || '撤回成功')
                this.showWithdrawModal = false
                this.withdrawRow = null
                this.getList()
            }).catch(err => {
                this.$Message.error((err && err.msg) || '撤回失败')
            }).finally(() => {
                this.withdrawSubmitting = false
            })
        },
        handleRegenerate(row) {
            this.regenerateRow = row
            this.regenerateContractName = this.getContractName(row)
            this.showRegenerateModal = true
        },
        confirmRegenerate() {
            if (!this.regenerateRow) return
            this.regenerateSubmitting = true
            contractApproveRegenerate({
                id: this.regenerateRow.id
            }).then(res => {
                this.$Message.success(res.msg || '已重新生成')
                this.showRegenerateModal = false
                this.regenerateRow = null
                this.getList()
            }).catch(err => {
                this.$Message.error((err && err.msg) || '重新生成失败')
            }).finally(() => {
                this.regenerateSubmitting = false
            })
        }
    }
}
</script>

<style scoped lang="scss">
.page-wrap {
    width: 100%;
}

.top-card {
    background: #fff;
    border-radius: 8px;
    padding: 20px 24px 8px;
    margin-bottom: 16px;
}

.nav_title {
    font-size: 18px;
    font-weight: 700;
    color: #1B2742;
    margin-bottom: 16px;
}

.input-group {
    .wrap {
        margin-right: 20px;
        margin-bottom: 12px;
        align-items: center;
    }
    .label {
        white-space: nowrap;
        color: #545F78;
        margin-right: 8px;
    }
}

.table_card {
    background: #fff;
    border-radius: 8px;
    padding: 16px 20px 20px;
}

.operation-btns {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
}

.table-btn {
    cursor: pointer;
    color: #4877E8;
    font-size: 13px;
    &:hover {
        opacity: 0.8;
    }
    &.danger {
        color: #ed4014;
    }
    &.approve-btn {
        color: #19be6b;
    }
    &.reject-reason-btn {
        color: #ff9900;
    }
    &.regenerate-btn {
        color: #ed4014;
    }
    &.del {
        color: #4877E8;
    }
}

.status-pending {
    color: #4877E8;
}
.status-reviewing {
    color: #2d8cf0;
}
.status-passed {
    color: #19be6b;
}
.status-rejected {
    color: #ed4014;
}
.status-revoked {
    color: #8A93A6;
}
.status-failed {
    color: #ed4014;
}

.approve-card {
    background: #F5F7FE;
    border-radius: 8px;
    padding: 16px;
}

.approve-card-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
}

.approve-contract-name {
    font-size: 15px;
    font-weight: 600;
    color: #1B2742;
    padding-right: 12px;
    word-break: break-all;
}

.view-contract-link {
    color: #4877E8;
    cursor: pointer;
    flex-shrink: 0;
    font-size: 13px;
}

.approve-info-row {
    margin-top: 8px;
    font-size: 13px;
    .info-label {
        color: #8A93A6;
    }
    .info-value {
        color: #333;
    }
}

.reject-form-tip {
    margin-bottom: 12px;
    color: #545F78;
    line-height: 1.5;
}

.reason-view-content {
    min-height: 80px;
    line-height: 1.7;
    color: #333;
    word-break: break-all;
}

.withdraw-content {
    display: flex;
    align-items: flex-start;
    line-height: 1.6;
    color: #333;
    .withdraw-icon {
        color: #ff9900;
        font-size: 22px;
        margin-right: 10px;
        margin-top: 2px;
    }
}
</style>
